import Alerts from 'components/common/Alerts'
type Props = {
  content: string[]
  name?: string
}

let ContactsView = ({ content, name }: Props) => {
  return (
    <div className='flex flex-col flex-grow custom-px'>
      <div className="lg:mb-4">
        <Alerts type='page.contacts' />
      </div>
      <h1 className='pt-4 lg:pt-0 font-unbounded font-medium text-2xl lg:text-5xl lg:leading-tight tracking-tight '>
        {name || 'Контакты'}
      </h1>

      <div dangerouslySetInnerHTML={{ __html: content[0] ?? '' }}></div>

      <div className='pt-2 lg:pt-4'>
        <div className='py-4 lg:py-8 lg:pr-10'>
          <div
            dangerouslySetInnerHTML={{ __html: content[1] ?? '' }}
          ></div>
        </div>
      </div>
      <div className='pt-2 lg:pt-4  lg:pr-10'>
        <h2 className='text-dark font-bold uppercase lg:text-center'>
          Наша команда
        </h2>
        <h2 className='mb-6 lg:text-center grey6c'>Выберите подходящий отдел для быстрого решения вашего вопроса</h2>
        <div
          className='mb-4'
          dangerouslySetInnerHTML={{ __html: content[2] ?? '' }}
        ></div>

        {/* <div className='mb-20 mt-10'>
          <div className='mb-4 text-dark text-xs font-unbounded font-bold uppercase leading-snug'>
            Карта обслуживания
          </div>
          <DeliveryMapInfo />
        </div> */}
      </div>
    </div>
  )
}

export default ContactsView
